<template>
  <div :class="{ bgf5: dataInfo }">
    <div class="bgfff pt20 pb40">
      <div class="f20 c222 fw600 flex justify-content-center align-items-center pt20 pb20 relative">
        查看物流
        <van-icon name="close" size="24px" color="#999999" style="position: absolute; right: 30px;" class="cpointer" @click.stop="cancel" />
      </div>
      <div v-if="dataInfo && dataInfo.IsPlatformRection===false">
        <div v-if="dataInfo" class="pt20 pl30 pr30 pb20">
          <van-row type="flex" align="center" class="product-box">
            <van-col>
              <div class="numbox">
                <van-image
                  :src="_getPic(shopIcon, true)"
                  fit="scale-down"
                  width="80px"
                  height="80px"
                />
                <div class="num">共{{ shopCount }}件商品</div>
              </div>
            </van-col>
            <van-col class="pl10" :span="20">
              <van-cell :value="`配送企业：${dataInfo.LogisticsCompanyName}`" value-class=" f14 c777" class="pb10 pl0 pr0" :border="false" />
              <van-cell :value="`快递单号：${dataInfo.LogisticsWaybillNo}`" value-class="f14 c777" class="pb10 pl0 pr0 pt0" :border="false" />
            </van-col>
          </van-row>
        </div>
      </div>

      <!-- 1.5.5 物流弹窗 -->
      <div v-if="logisticsData.length > 0" class=" pl30 pr30 pb20 scrollWrapper logistics-box">
        <div v-if="dataInfo.IsPlatformRection" style="padding-left: 165px; text-align: left;">
          <div>配送方式：平台直配</div>
        </div>
        <div class="flex-box">
          <div v-if="logisticsData.length > 1" class="flex-box-menu" style="border: 0;">
            <a-radio-group v-for="(item, index) in logisticsData" :key="index" v-model="changeVal" @change="onChangeLogistics">
              <a-radio :value="item.LogisticsWaybillNo">包裹{{ index + 1 }}</a-radio>
            </a-radio-group>
          </div>
          <div class="flex-box-cont">
            <van-steps direction="vertical" :active="0" class="text-left pl30" active-color="#222222">
              <van-step v-for="(item, index) in changeData" :key="index" style="padding: 12px 0;">
                <div class="c777 f14 pl20 mb5">{{ item.Title }}</div>
                <div class="c777 f14 pl20 mb5">{{ item.Note }}</div>
                <div class="c222 f12 pl20">{{ item.Time }}</div>
                <template #active-icon>
                  <van-icon :name="require('@/assets/order/yunshuzhong-icon.png')" size="26px" />
                </template>
                <template #inactive-icon>
                  <van-icon v-if="changeData.length - 1 == index" :name="require('@/assets/order/yunshu-n-icon.png')" size="26px" />
                </template>
              </van-step>
            </van-steps>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { BaseMixin } from '../../mixins/BaseMixin.js'
export default {
  name: 'ViewLogistics',
  mixins: [BaseMixin],
  data() {
    return {
      Id: null,
      dataInfo: null,
      // 物流包裹切换参数
      changeVal: '',
      logisticsData: [],
      changeData: [],
      // 商品总数
      shopCount: 0,
      // 商品图片
      shopIcon: null
    }
  },
  computed: {
    ImageLogo() {
      if (!this.dataInfo.LogisticsDocmentGoods || !this.dataInfo.LogisticsDocmentGoods.length) {
        return null
      }
      if (!this.dataInfo.LogisticsDocmentGoods[0].bCommodityDTO) {
        return null
      }
      return this.dataInfo.LogisticsDocmentGoods[0].bCommodityDTO.Logo
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 物流包裹切换点击监听
    onChangeLogistics(e) {
      // 根据选中包裹的ID，匹配数据集合，渲染对应物流数据
      this.logisticsData.forEach(l => {
        if (e.target.value === l.LogisticsWaybillNo) {
          this.changeData = l.LogisticsDocmentTrail
          this.dataInfo = l
        }
      })
    },
    // 物流信息
    async getLogistics() {
      this.$hys.openLoading()
      const res = await this.postAction('/api_logistics/LogisticsDocment/GetLogisticsDocmentByOrderIds?businessDocmentType=1', [this.Id])
      this.$hys.clearLoading()
      if (res.IsSuccess && res.Data) {
        if (!res.Data.length) return
        const arr = []
        res.Data.forEach(item => {
          if (item.BusinessDocmentType === 1) { // 订单物流
            if (item.LogisticsDocmentState === 2) {
              item.stateName = '运输中'
            } else if (item.LogisticsDocmentState === 3) {
              item.stateName = '运输中'
            } else if (item.LogisticsDocmentState === 4) {
              item.stateName = '部分签收'
            } else if (item.LogisticsDocmentState === 5) {
              item.stateName = '已签收'
            } else {
              item.stateName = '待出库'
            }
            arr.push(item)
          }
          // 获取总商品数
          if (item.LogisticsDocmentGoods && item.LogisticsDocmentGoods.length > 0) {
            let Count = 0
            item.LogisticsDocmentGoods.map(nums => {
              Count = Number(nums.Count + Count)
              // 获取商品图片
              this.shopIcon = nums.bCommodityDTO.Logo
            })
            this.shopCount = Count
          }
        })
        this.logisticsData = arr
        if (this.logisticsData.length > 0) {
          // 默认设置展示第一个包裹物流信息
          this.changeVal = arr[0].LogisticsWaybillNo
          this.changeData = arr[0].LogisticsDocmentTrail
          this.dataInfo = arr[0]
        }
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    cancel() {
      this.$emit('cancel')
      this.logisticsData = []
      this.changeVal = []
      this.changeData = []
      this.dataInfo = []
    },
    init(id) {
      this.Id = id
      this.getLogistics()
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/styles/orderDetails.less');

/deep/.numbox {
  position: relative;
  width: 100px;
  height: 100px;

  .num {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    font-size: 14px;
    color: #FFFFFF;
    background: rgba(0, 0, 0, .6);
    line-height: 24px;
  }
}

.product-box {
  border-radius: 1px;
  box-shadow: 0 1px 4px 0 rgba(223, 223, 223, .5);
}

.scrollWrapper {
  overflow-y: auto;
  max-height: 400px;

  &::-webkit-scrollbar {
    /* 滚动条整体样式 */
    width: 10px;

    /* 高宽分别对应横竖滚动条的尺寸 */
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    /* 滚动条里面小方块 */
    border-radius: 10px;
    background: #E8E8E8;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #F5F5F5;

    /* 滚动条里面轨道 */
    box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
  }
}

.logistics-box {
  /deep/ .van-steps {
    padding-left: 165px;

    /deep/ .van-step {
      /deep/ .van-step__title {
        div {
          &:last-child {
            position: absolute;
            top: 10px;
            left: -182px;
          }
        }
      }
    }
  }
}
</style>
